import React, { useState } from 'react';
import { Icon } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import styles from './ProductionReviewDashboardMenu.module.css';
import { TIME_DURATION } from '../../constants';
import {
  calculateStartDateTimeWithZoneInfo,
  calculateEndDateTimeWithZoneInfo,
  calculateDateRangeForCurrentDurationForWeekWiseGraph,
  calculateDateRangeForPreviousDurationForWeekWiseGraph,
  calculateDateRangeForCurrentDurationForMonthWiseGraph,
  calculateDateRangeForPreviousDurationForMonthWiseGraph,
} from '../../utils/graphDataUtils';
import factory from '../../icons/awesome-industry.svg';
import industry from '../../icons/industry-solid.svg';
import PlantDropdownSelector from '../PlantDropdownSelector/PlantDropdownSelector';
import LineDropdownSelector from '../LineDropdownSelector/LineDropdownSelector';

const ProductionReviewDashboardMenu = ({
  handleDurationTextChange,
  handleStartDateChange,
  handleEndDateChange,
  sequenceAdherenceDashBoard,
  setPlantValueForSequenceAdherence,
  setLineValueForSequenceAdherence,
  plantValue,
}) => {
  const [selectedTimeDuration, setTimeDuration] = useState('1');

  const timeDurationOptions = [
    { value: '1', name: TIME_DURATION.LAST_SEVEN_DAYS },
    { value: '2', name: TIME_DURATION.LAST_FOUR_WEEKS },
  ];
  const timeDurationOptionsForSequenceAdherence = [
    { value: '1', name: TIME_DURATION.LAST_SEVEN_DAYS },
    { value: '2', name: TIME_DURATION.LAST_FOUR_WEEKS },
    { value: '3', name: TIME_DURATION.LAST_SIX_MONTHS },
  ];

  const onTimeDurationChange = event => {
    const duration = event.target.value;
    const durationText = event.target.name;
    setTimeDuration(duration);
    handleDurationTextChange(durationText);
    const [
      startDateTime,
      endDateTime,
    ] = computeStartAndEndDateTimeForSelectedDuration(durationText, false);

    handleStartDateChange(startDateTime);
    handleEndDateChange(endDateTime);
  };

  const computeStartAndEndDateTimeForSelectedDuration = (
    selectedDuration,
    isPreviousDuration,
  ) => {
    let startDateTime;
    let endDateTime;

    if (selectedDuration === TIME_DURATION.LAST_SEVEN_DAYS) {
      if (!isPreviousDuration) {
        startDateTime = calculateStartDateTimeWithZoneInfo(6);
        endDateTime = calculateEndDateTimeWithZoneInfo();
      } else {
        startDateTime = calculateStartDateTimeWithZoneInfo(6 + 7);
        endDateTime = calculateEndDateTimeWithZoneInfo(7);
      }
    } else if (selectedDuration === TIME_DURATION.LAST_FOUR_WEEKS) {
      if (!isPreviousDuration) {
        [
          startDateTime,
          endDateTime,
        ] = calculateDateRangeForCurrentDurationForWeekWiseGraph();
      } else {
        [
          startDateTime,
          endDateTime,
        ] = calculateDateRangeForPreviousDurationForWeekWiseGraph();
      }
    } else {
      if (!isPreviousDuration) {
        [
          startDateTime,
          endDateTime,
        ] = calculateDateRangeForCurrentDurationForMonthWiseGraph();
      } else {
        [
          startDateTime,
          endDateTime,
        ] = calculateDateRangeForPreviousDurationForMonthWiseGraph();
      }
    }
    return [startDateTime, endDateTime];
  };

  return (
    <>
      <div>
        <div className={styles.title}>Our dashboard</div>
        <div className={styles.mainBody}>
          <div id="plant" className={styles.line}>
            <span className={styles.label}>Select Plant(s)</span>
            <Icon className={styles.plantIc}>
              <img
                src={industry}
                alt="Select Plant"
                className={styles.plantIc}
              />
            </Icon>
            <PlantDropdownSelector
              isDarkStyle={true}
              sequenceAdherenceDashBoard={sequenceAdherenceDashBoard}
              setPlantValueForSequenceAdherence={
                setPlantValueForSequenceAdherence
              }
            />
          </div>

          <div id="line" className={styles.line}>
            <span className={styles.label}>Select Line(s)</span>
            <Icon className={styles.plantIc}>
              <img
                src={factory}
                alt="Select Line"
                className={styles.plantIc1}
              />
            </Icon>
            <LineDropdownSelector
              isDarkStyle={true}
              sequenceAdherenceDashBoard={sequenceAdherenceDashBoard}
              setLineValueForSequenceAdherence={
                setLineValueForSequenceAdherence
              }
              plantValue={plantValue}
            />
          </div>
          <div id="duration">
            <span className={styles.orTitle}>Time Period</span>
            <RadioGroup
              aria-label="time"
              name="time-period"
              value={selectedTimeDuration}
              onChange={onTimeDurationChange}
              className={styles.radio}
            >
              {sequenceAdherenceDashBoard === 'Seq. Adherence'
                ? timeDurationOptionsForSequenceAdherence.map(timeDuration => (
                  <FormControlLabel
                    value={timeDuration.value}
                    control={<Radio />}
                    name={timeDuration.name}
                    label={timeDuration.name}
                  />
                ))
                : timeDurationOptions.map(timeDuration => (
                  <FormControlLabel
                    value={timeDuration.value}
                    control={<Radio />}
                    name={timeDuration.name}
                    label={timeDuration.name}
                  />
                ))}
            </RadioGroup>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductionReviewDashboardMenu;
